import { render, staticRenderFns } from "./olderList.vue?vue&type=template&id=b3a070ba&scoped=true&"
import script from "./olderList.vue?vue&type=script&lang=js&"
export * from "./olderList.vue?vue&type=script&lang=js&"
import style0 from "./olderList.vue?vue&type=style&index=0&id=b3a070ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a070ba",
  null
  
)

export default component.exports